// extracted by mini-css-extract-plugin
export default {"bodyBox":"styles_bodyBox__KfoCA","scroller":"styles_scroller__C+UDn"};